import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { ProblemAgitation } from './components/ProblemAgitation';
import { SolutionSection } from './components/SolutionSection';
import { BenefitsSection } from './components/BenefitsSection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { FloatingCTA } from './components/FloatingCTA';
import { SocialProofBar } from './components/SocialProofBar';
import { ObjectionBuster } from './components/ObjectionBuster';
import { LiveNotification } from './components/LiveNotification';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '572868155413350');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Noscript pixel
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=572868155413350&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  useEffect(() => {
    // Intersection Observer for fade-in animations
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // Optional: stop observing once animated
          // observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    const elements = document.querySelectorAll('.fade-in-section');
    elements.forEach(el => observer.observe(el));
    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, []);
  return <div className="min-h-screen bg-bg-warm font-body text-text-dark selection:bg-coral/30 selection:text-coral-dark" data-id="element-0">
      {/* Top Announcement Bar */}
      <div className="bg-coral-dark text-white text-center py-2 px-4 text-sm font-medium tracking-wide" data-id="element-1">
        🔥 OFERTA ESPECIAL: 50% de descuento · Envío digital inmediato ⚡️ ·
        Quedan pocas unidades
      </div>

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainPoints data-id="element-4" />
        <SocialProofBar data-id="element-5" />
        <ProblemAgitation data-id="element-6" />
        <SolutionSection data-id="element-7" />
        <BenefitsSection data-id="element-8" />
        <WhatsIncluded data-id="element-9" />
        <Testimonials data-id="element-10" />
        <Guarantee data-id="element-11" />
        <ObjectionBuster data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>

      {/* Footer */}
      <footer className="bg-text-dark text-text-light py-8 text-center text-sm" data-id="element-15">
        <div className="container mx-auto px-4" data-id="element-16">
          <p className="mb-2" data-id="element-17">
            © {new Date().getFullYear()} Reinicia tu Metabolismo. Todos los
            derechos reservados.
          </p>
          <p className="text-xs opacity-60 max-w-2xl mx-auto" data-id="element-18">
            Este producto no sustituye el consejo médico profesional. Los
            resultados pueden variar de persona a persona. Al usar este sitio,
            aceptás nuestros términos y condiciones.
          </p>
        </div>
      </footer>

      <FloatingCTA data-id="element-19" />
      <LiveNotification data-id="element-20" />
    </div>;
}